export const PATHWAY_REQUIREMENT_TYPES = {
    badge: 'badge',
    pathway: 'pathway_feed_item',
    pathwayAssignment: 'pathway_assignment',
    courseAssignment: 'course_assignment',
    experience: 'experience',
};
